import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const RemoveButton = props => {
  const { camper, setModal, align } = props
  if (camper.hasRegisteredPlans) {
    return null
  }

  const handleClickRemove = () =>
    setModal({ id: `confirmDeleteCamper${camper.id}`, open: true })

  return (
    <ResponsiveButton onClick={handleClickRemove} align={align}>
      Remove
    </ResponsiveButton>
  )
}

export default RemoveButton
